import FormContainer from "@client/content/controls/Form/container";
import { getRootContainerProps } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import { type FormFieldInfo, type FormHandles } from "@client/controls/Form/component";
import AddressInput from "@client/controls/Inputs/TextInput/Address/component";
import withIsVisibleHOC, { type WithIsVisibleHOCProps } from "@client/hocs/withIsVisible";
import { fieldValidation } from "@common/controls/Form/Field/lib";
import { useI18n } from "@common/hooks/i18n";
import { identity } from "lodash";
import * as React from "react";
import { withOnSubmit } from "../../hooks";

export type MapProps = WithIsVisibleHOCProps &
  RootContainerProps & {
    email: string | null;
  };

export interface ActionProps {
  onChange: (name: string, value: any) => void;
}

export type Props = ActionProps & MapProps;

export default withIsVisibleHOC((props: Props) => {
  const i18n = useI18n();

  const ref = withOnSubmit<FormHandles>(identity);

  const fields: FormFieldInfo[] = [
    {
      name: "email",
      label: i18n.email,
      isRequired: true,
      Component: AddressInput,
      defaultValue: props.email,
      componentOpts: { onChangeTrigger: "blur" },
      validation: fieldValidation.email,
      qa: "Email"
    }
  ];

  return (
    <div className="contact_information">
      <h4>{i18n.contact}</h4>

      <FormContainer
        {...getRootContainerProps(props)}
        ref={ref}
        fields={fields}
        onChange={props.onChange}
        validateOn="change"
      />
    </div>
  );
});
